import { Checkbox } from 'braid-design-system';
import type React from 'react';

interface WorkTypeItemProps {
  workTypesFieldValues: number[];
  workType: number;
  label: string;
  isChecked: boolean;
  onChange: (arg0: number[]) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const WorkTypeItem = ({
  workTypesFieldValues,
  workType,
  label,
  isChecked,
  onChange,
  inputRef,
}: WorkTypeItemProps) => {
  const checkBoxId = label.replace(/\s+/g, '-').toLowerCase();

  const toggle = () => {
    const newWorkTypes = workTypesFieldValues.includes(workType)
      ? workTypesFieldValues.filter((type) => type !== workType)
      : [...workTypesFieldValues, workType];

    onChange(newWorkTypes);
  };

  return (
    <Checkbox
      id={checkBoxId}
      name="work-types"
      onChange={toggle}
      checked={isChecked}
      ref={inputRef}
      label={label}
      data={{ automation: checkBoxId }}
      message={false}
    />
  );
};
